import { X } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { twMerge } from 'tailwind-merge'

const DismissiblePill = ({ label, className, onDismiss }) => (
  <>
    <Badge variant='secondary' className={className}>
      {label}

      <button onClick={onDismiss} className='ml-1'>
        <X size={16} />
      </button>
    </Badge>
  </>
)

export default DismissiblePill
